import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; 
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyA-9lJrjgWJvekEjSwyI1u49wHAt02hoA0",
  authDomain: "simbascholarship.firebaseapp.com",
  projectId: "simbascholarship",
  storageBucket: "simbascholarship.appspot.com",
  messagingSenderId: "1005585844429",
  appId: "1:1005585844429:web:e18a01a933c38c7926c184",
  measurementId: "G-NN07Y57Q8Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// ✅ Initialize Firestore database
const db = getFirestore(app);

export { db, analytics };
